import apis from "../../core/apis.js";

class LoginResource {
  constructor($resource) {
    "ngInject";
    this.$resource = $resource;
  }
  post(data) {
    return this.$resource(apis.login).save(data);
  }

  refresh(data) {
    return this.$resource(apis.refreshToken).save(data);
  }
  signInWithGoogle(data) {
    return this.$resource(apis.googleSignInUrl).save(data);
  }
}

export default LoginResource;



// WEBPACK FOOTER //
// ./src/resources/login/login.resource.js